import { type FC } from "react";
import { InformationPage } from "../../common/components/informationPage/InformationPage";
import { MAIL_SENT } from "../../utils/url/staticResources";

import { WISHLIST_PAGE } from "../../utils/url/staticUrls";
import { Button } from "~/common/components/Button/Button";
import { useTranslation } from "react-i18next";

interface Props {
  wishlistName: string;
}

const ShareWishlistConfirmationPage: FC<Props> = ({ wishlistName }) => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>{t("page.shareWishlistConfirmation.title", { wishlistName })}</InformationPage.Title>
      <InformationPage.Image src={MAIL_SENT} />
      <Button href={WISHLIST_PAGE}>{t("share.wishlist.confirmation.back.btn")}</Button>
    </InformationPage.CenterContents>
  );
};

export function createShareWishlistConfirmationPage(wishlistName: string) {
  return <ShareWishlistConfirmationPage wishlistName={wishlistName} />;
}
